import React from 'react';
import timeStampToDate from 'helpers/time-stamp-to-date';
import { QuestionsAndAnswersItemInterface } from 'modules/product/views/components/product-questions-answers/interfaces/questions-and-answers-item.interface';
import QuestionIcon from 'assets/icons/global/ikona-pytanie.svg';
import ProductAnswers from 'modules/product/views/components/product-questions-answers/components/product-answers';

import './product-question.scss';

export interface ProductQuestionProps {
    offerLink?: string;
    author: QuestionsAndAnswersItemInterface['author'];
    createdAt: QuestionsAndAnswersItemInterface['createdAt'];
    text: QuestionsAndAnswersItemInterface['text'];
    answers: QuestionsAndAnswersItemInterface['children'];
}

const ProductQuestion: React.FC<ProductQuestionProps> = ({ offerLink, author, createdAt, text, answers }) => {
    return (
        <div className="question">
            <div className="question__wrapper">
                <img
                    className="question__image"
                    src={QuestionIcon}
                    alt={author}
                    width={40}
                    height={40}
                />
                <span className="question__name">{author}</span>
                <span className="question__date">{timeStampToDate(createdAt).fromNow()}</span>
            </div>
            <p className="question__text">
                {text}
            </p>
            {answers && answers.length > 0 && (
                <ProductAnswers
                    offerLink={offerLink}
                    answers={answers}
                />
            )}
        </div>
    );
};

export default ProductQuestion;
